import React from 'react';
import { Lock, ArrowUpRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { LockedFeatureInfo } from '../navigation/featureAccess';
import './LockedFeaturePanel.css';
import { useFeatureAccess } from '../contexts/FeatureAccessContext';
import { getUpgradeLabel } from '../navigation/featureAccess';

interface LockedFeaturePanelProps {
  feature: LockedFeatureInfo;
}

const LockedFeaturePanel: React.FC<LockedFeaturePanelProps> = ({ feature }) => {
  const navigate = useNavigate();
  const { account } = useFeatureAccess();
  const requiredPlanLabel = feature.requiredPlan.charAt(0).toUpperCase() + feature.requiredPlan.slice(1);

  return (
    <div className="locked-feature-panel" role="status" aria-live="polite">
      <div className="locked-feature-icon" aria-hidden="true">
        <Lock size={22} />
      </div>
      <div className="locked-feature-copy">
        <span className="locked-feature-eyebrow">{requiredPlanLabel} plan required</span>
        <h2>{feature.featureName}</h2>
        <p>{feature.reason} {feature.freePlanMessage}</p>
      </div>
      <button
        type="button"
        className="locked-feature-action"
        onClick={() => navigate(feature.upgradePath)}
      >
        {getUpgradeLabel(account)}
        <ArrowUpRight size={16} />
      </button>
    </div>
  );
};

export default LockedFeaturePanel;
